import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';

import { addFavorite, deleteFavorite } from 'core/actions/member';
import { selectFavoritesIsProcessed, makeSelectFavoriteByMerchantId } from 'core/selectors/favorites';

/*
  This component could be potentially refactored to just reference the existing FavoriteIcon component and override
  CSS to cover the appropriate area. This component was done to meet a quick deadline and was original approach.

  See the existing favorites bundles as an alternative approach to this one where here, there's some duplicated logic
  around triggering the add/deleteFavorite actions.
 */
function PotentialFavorite({ merchantId, merchantName, logoUrl }) {
  const dispatch = useDispatch();

  const selectFavoriteByMerchantId = useMemo(makeSelectFavoriteByMerchantId, []);

  const isProcessed = useSelector(selectFavoritesIsProcessed);
  const isFavorited = useSelector(state => selectFavoriteByMerchantId(state, merchantId));

  const getIsProcessing = () => !isProcessed;

  const handleFavoriteClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (merchantId && !getIsProcessing()) {
      if (isFavorited) {
        dispatch(deleteFavorite(merchantId));
      } else {
        dispatch(addFavorite(merchantId, {}, {}, { forceSkipFirstFavoritesPopup: true }));
      }
    }

    return false;
  };

  if (!merchantId) {
    return (null);
  }

  return (
    <div
      role="button"
      tabIndex="0"
      className="mn_potentialFavorite"
      onClick={handleFavoriteClick}
    >
      <FavoriteIcon
        merchantId={merchantId}
        merchantName={merchantName}
        tooltipEnabled={false}
        forceSkipFirstFavoritesPopup
      />
      <img className="mn_merchantLogo" data-merchant-id={merchantId} src={logoUrl} alt={merchantName} />
    </div>
  );
}

export default PotentialFavorite;
